module.exports = __webpack_public_path__ + "static/img/images_AS01.a4693ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_AS01.jpg
// module id = k/xS
// module chunks = 0